export const kSampleIdVariable = "id";
export const kSampleUuidVariable = "uuid";
export const kSampleMetadataVariable = "metadata";
export const kSampleMetadataPrefix = kSampleMetadataVariable + ".";

export const KEYWORDS: string[] = ["and", "or", "not", "in", "not in", "mod"];

export const MATH_FUNCTIONS: [string, string][] = [
  ["min", "Minimum of two or more values"],
  ["max", "Maximum of two or more values"],
  ["abs", "Absolute value"],
  ["round", "Round to the nearest integer"],
  ["floor", "Round down to the nearest integer"],
  ["ceil", "Round up to the nearest integer"],
  ["sqrt", "Square root"],
  ["log", "Natural logarithm"],
  ["log2", "Base 2 logarithm"],
  ["log10", "Base 10 logarithm"],
];

export const SAMPLE_VARIABLES: [string, string][] = [
  ["epoch", "The epoch (run) number of the sample"],
  ["completed", "Whether the sample completed (true unless still running)"],
  ["has_error", "Checks if the sample has an error"],
  ["has_limit", "Checks if the sample stopped due to a limit"],
  ["has_retries", "Checks if the sample has been retried"],
  ["has_fallbacks", "Checks if any model fallback occurred in the sample"],
  [kSampleIdVariable, "The unique identifier of the sample"],
  [kSampleUuidVariable, "The globally unique identifier of the sample run"],
  ["input", "The sample input as a string"],
  ["target", "The sample target as a string"],
  ["answer", "The sample answer (from the selected scorer)"],
  ["error", "The sample error message (or null)"],
  ["limit", "The limit kind that stopped the sample (or null)"],
  ["retries", "The number of times the sample was retried (0 if none)"],
  [
    "fallbacks",
    "The number of requests served by a fallback model (0 if none)",
  ],
  ["tokens", "Total tokens used across all models (or null)"],
  ["duration", "Total wall-clock time of the sample, in seconds (or null)"],
  [kSampleMetadataVariable, "Metadata associated with the sample"],
];

export const SAMPLE_FUNCTIONS: [string, string][] = [
  ["input_contains", "Checks if input contains a regular expression"],
  ["target_contains", "Checks if target contains a regular expression"],
  ["answer_contains", "Checks if answer contains a regular expression"],
  ["error_contains", "Checks if error contains a regular expression"],
  ["is_nan", "Checks if a numeric value is NaN (e.g. is_nan(score))"],
];
